import { render } from "./CollectionAdvancedSettingsModal.vue?vue&type=template&id=14065f20&scoped=true"
import script from "./CollectionAdvancedSettingsModal.vue?vue&type=script&lang=js"
export * from "./CollectionAdvancedSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14065f20"]])

export default __exports__